module.exports = __webpack_public_path__ + "static/media/playstore-6a.3c2c19b8.png";